import useMutation from "src/hooks/useMutation";

function useBrandCreate() {
  return useMutation({
    path: "/api/v1/brands",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/brands`,
      shouldRevalidate: true,
    },
  });
}

export default useBrandCreate;
